var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSecurityWaitingTimes = function SvgSecurityWaitingTimes(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.99997 17.889C13.9092 17.889 17.8889 13.9093 17.8889 9.00009C17.8889 4.0909 13.9092 0.111206 8.99997 0.111206C4.09077 0.111206 0.111084 4.0909 0.111084 9.00009C0.111084 13.9093 4.09077 17.889 8.99997 17.889ZM10.3333 3.66663C10.3333 2.93025 9.73632 2.33329 8.99994 2.33329C8.26356 2.33329 7.66661 2.93025 7.66661 3.66663V8.99996C7.66661 9.50499 7.95194 9.96667 8.40365 10.1925L11.9592 11.9703C12.6178 12.2996 13.4187 12.0327 13.7481 11.374C14.0774 10.7154 13.8104 9.91449 13.1518 9.58517L10.3333 8.17591V3.66663Z",
    fill: "currentColor"
  })));
};
export default SvgSecurityWaitingTimes;